import { Injectable } from '@angular/core';
import { get } from 'lodash';
import { AuthResult } from 'node_modules/angular-auth-oidc-client/lib/flows/callback-context';
import { BehaviorSubject } from 'rxjs';
import { Location } from '../shared/models/location';
import { User } from '../shared/models/user';
import { UserRole } from '../shared/models/user-role';

@Injectable({
  providedIn: 'root',
})
export class AuthStore {
  private userInfo: User;
  private authResult: AuthResult;
  public userInfo$: BehaviorSubject<User> = new BehaviorSubject<User>(null);

  initializeLogInUser(user: User): void {
    this.userInfo = user;
    this.userInfo$.next(user);
  }

  initializeCredentials(authResult: AuthResult): void {
    this.authResult = authResult;
  }

  setLocation(location: Location): void {
    this.userInfo.selectedLocation = location;
    this.userInfo$.next(this.userInfo);
  }

  setRole(role: UserRole): void {
    this.userInfo.selectedRole = role;
    this.userInfo.locationsForSelectedRole = get(role, 'locations');
    this.userInfo$.next(this.userInfo);
  }

  get UserInfo(): User {
    return this.userInfo;
  }

  get AuthResult(): AuthResult {
    return this.authResult;
  }

  get UserInfo$(): BehaviorSubject<User> {
    return this.userInfo$;
  }

  isAuthenticated(): boolean {
    return !!this.authResult?.access_token;
  }

  getAccessToken(): string {
    return this.authResult?.access_token || '';
  }

  getIdToken(): string {
    return this.authResult?.id_token || '';
  }

  authorizationHeaderValue(): string {
    return `dpop ${this.getAccessToken()}`;
  }
}
